webpackJsonp([174011254851047],{

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SuhelaKhan = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _insights_constants = __webpack_require__(25);
	
	var _reactBootstrap = __webpack_require__(22);
	
	var _reactSpinners = __webpack_require__(21);
	
	var _jquery = __webpack_require__(26);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactResponsive = __webpack_require__(23);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	__webpack_require__(10);
	
	var _reactAnimateOnScroll = __webpack_require__(11);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _reactPlayer = __webpack_require__(32);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _sendMailIcon = __webpack_require__(30);
	
	var _sendMailIcon2 = _interopRequireDefault(_sendMailIcon);
	
	var _MailForwardForm = __webpack_require__(27);
	
	var _MailForwardForm2 = _interopRequireDefault(_MailForwardForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/kyra-anoushka.png";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide,
	      style: { margin: "0% auto 0px" }
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          activeItem.post
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SuhelaKhan = exports.SuhelaKhan = function (_React$Component) {
	  _inherits(SuhelaKhan, _React$Component);
	
	  function SuhelaKhan(args) {
	    _classCallCheck(this, SuhelaKhan);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.toggleMailShareForm = function () {
	      _this.setState({ showMailShareForm: !_this.state.showMailShareForm });
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.handleMenu = function (item) {
	      _this.setState({
	        activeTitle: item.title
	      });
	
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      if (item.title === "SORT BY") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else if (item.title === "ALL") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else {
	        [].concat(leftlist).filter(function (insight) {
	          console.log(insight);
	          // a.typee.indexOf(item.title) >= 0}
	          var flag = false;
	          for (var i = 0; i < insight.itype.length; i++) {
	            if (item.title === insight.itype[i]) {
	              flag = true;
	            }
	          }
	          return flag;
	        }).forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      }
	      _this.setState({
	        activeSortBy: item.title
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.handleSearch = function (e) {
	      var str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
	      _this.setState({
	        isSearching: true,
	        activeKeyword: str
	      });
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      leftlist.forEach(function (item) {
	        if (item.skey.toLowerCase().trim().search(str) > -1) {
	          _this.betterContent.push(item);
	        }
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false,
	      activeKeyword: "",
	      isSearching: false,
	      lastCounter: 3,
	      activeTitle: "SORT BY",
	      activeSortBy: "default",
	      showMailShareForm: false
	    };
	    _this.betterContent = _insights_constants.insightsConstants;
	
	    _this.Speaker = [{
	      desc: "<div> \n        </div>",
	      name: "Anoushka Menezes & Kyra Menezes",
	      post: "Grade 12 Student",
	      imgUrl: icon1,
	      head: "Entrepreneurship Is Still a Boys’ Club"
	    }];
	    return _this;
	  }
	
	  SuhelaKhan.prototype.componentDidMount = function componentDidMount() {
	    // function sticky_relocate () {
	    // 	var window_top = $(window).scrollTop()
	    // 	var div_top = $("#sticky-anchor").offset().top
	    // 	if (window_top > div_top) {
	    // 		$("#sticky").addClass("stick")
	    // 	} else {
	    // 		$("#sticky").removeClass("stick")
	    // 	}
	    // }
	    // $(function () {
	    // 	$(window).scroll(sticky_relocate)
	    // 	sticky_relocate()
	    // })
	  };
	
	  SuhelaKhan.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isSearching = _state.isSearching,
	        isShow = _state.isShow,
	        activeTitle = _state.activeTitle,
	        activeSortBy = _state.activeSortBy;
	    var location = this.props.location;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _contentPage2.default,
	        null,
	        _react2.default.createElement(_meta2.default, {
	          title: "Entrepreneurship Is Still a Boys\u2019 Club",
	          image: "https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg",
	          description: "In the 2020s, women continue to be shortchanged in the world of entrepreneurship, despite their growing drive to build their own businesses. While statistics trumpet their increased hustling, they receive a mere 2% of venture capital. This isn\u2019t just unfair; it\u2019s detrimental to the economy. ",
	          location: location
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "section__content" },
	          _react2.default.createElement(
	            "div",
	            { className: "insights_wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "insights_section" },
	              _react2.default.createElement(
	                "div",
	                { className: "insights_content" },
	                _react2.default.createElement("div", { className: "drop_src_box" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights_mid_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-12 col-md-12" },
	                      _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                          delay: 0,
	                          duration: 2,
	                          animateIn: "slideInRight",
	                          offset: 600
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "insights_right_text" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights_blog_page" },
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text" },
	                              this.Speaker.map(function (item, i) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  { className: "row" },
	                                  _react2.default.createElement(
	                                    _reactAnimateOnScroll2.default,
	                                    {
	                                      delay: 0,
	                                      duration: 1,
	                                      animateIn: "zoomIn",
	                                      offset: 100
	                                    },
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-3 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        {
	                                          className: "right_img_section"
	
	                                        },
	                                        _react2.default.createElement("img", {
	                                          src: item.imgUrl, style: { width: '100%' },
	                                          alt: "Suhela khan",
	                                          className: "img-responsive"
	                                        })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-9 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "right_name_section" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_head" },
	                                          item.head
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_name" },
	                                          item.name
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_post" },
	                                          "Grade 12 Student "
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_block" },
	                                          _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            " "
	                                          ),
	                                          " \u2022 6 mins read"
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "share_section_one" },
	                                        _react2.default.createElement("div", { className: "headsocialLink" })
	                                      )
	                                    )
	                                  )
	                                );
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text_btm" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "text_section" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "into_text", style: { fontStyle: 'normal' } },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: " ", style: { textAlign: 'left' } },
	                                    "In the 2020s, women continue to be shortchanged in the world of entrepreneurship, despite their growing drive to build their own businesses. While statistics trumpet their increased hustling, they receive a mere 2% of venture capital. This isn\u2019t just unfair; it\u2019s detrimental to the economy. Across all levels, the data shows the untapped potential of women-owned businesses and an urgent need to overcome systemic biases.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Gender disparities in entrepreneurship extend to India as well, as shown by the 2021 Mastercard Index of Women Entrepreneurs. Classified as an underperformer, India showcased a significant lag in facilitating the professional advancement of women business leaders. Alarmingly, India stands at the 59th position among 65 countries with women entrepreneurs, with women accounting for a 6% share of all business owners. India\u2019s sub-optimal footing underscores the importance of addressing systemic barriers to ensure a more inclusive and equitable entrepreneurial ecosystem.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Challenges for women in entrepreneurship are manifold, including access to funding. Harvard Business School reports a striking bias in investor preferences, revealing that pitches by men are more likely to secure funding compared to those by women. This bias is influenced by factors such as physical attractiveness despite identical pitch content, illustrating the deep-seated challenges women face in securing funding.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Inversely, the benefits of women entrepreneurs in the business landscape are numerous. Forbes emphasises the unique perspectives proffered by women, particularly in developing services tailored to the needs of women. Research further highlights women\u2019s prowess as collaborators and skilled multitaskers. An Australian study from 2019\u20132020, as reported by Inside Ageing, reveals that for every dollar of funding, female-founded startups made 78 cents, surpassing male-founded startups, which made just 31 cents. Data from the Court of Arbitration of the European Chamber of Digital Commerce shows that women-owned firms not only generate significantly higher revenue but also showcase superior effectiveness in senior leadership roles.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "In conclusion, the persisting disparity in venture capital funding for male and female entrepreneurs signals not only an economic challenge but a missed opportunity for innovation and growth. Systemic biases unveiled in investor preferences also demand a comprehensive reevaluation of gender inclusivity in the investing world to foster a more inclusive entrepreneurial environment. Despite the numerous benefits that women entrepreneurs have demonstrated, these advantages remain underutilised. Moving forward, dismantling barriers and improving women\u2019s access to capital are imperative for a thriving entrepreneurial landscape.",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    "Author",
	                                    _react2.default.createElement("br", null),
	                                    "Anoushka Menezes & Kyra Menezes",
	                                    _react2.default.createElement("br", null),
	                                    "Grade 12 Student",
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement("br", null),
	                                    _react2.default.createElement(
	                                      "h4",
	                                      null,
	                                      "Source:"
	                                    ),
	                                    _react2.default.createElement(
	                                      "ul",
	                                      null,
	                                      _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Pitchbook 2022 Female Founders Year in Review, December 18, 2022."
	                                      ),
	                                      _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Niti Aayog Report,\u201CDecoding government support to women entrepreneurs in India\u201D,October 2022."
	                                      ),
	                                      _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Mastercard Report, \u201CThe Mastercard Index of Women Entrepreneurs,\u201D March 2022."
	                                      ),
	                                      _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "BCG Report, \u201CWhy women owned startups are a better bet\u201D, June 2018."
	                                      )
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement("div", { className: "r_text_Q" }),
	                                _react2.default.createElement("div", { className: "r_text_Q" })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(TeamModal, {
	              show: isShow,
	              onHide: this.togglePopUp,
	              activeItem: this.state.activeItem
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return SuhelaKhan;
	}(_react2.default.Component);
	
	SuhelaKhan.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SuhelaKhan;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-entrepreneurship-is-still-a-boys-club-index-js-ee730ac1b27a52265c0b.js